<template lang="pug">
	header.new-header-back-desktop
		nav#menu.menu-container
			.h-content
				.first-item-new-menu
					a.logo(href="/")
						sfc-logo-desktop
				.second-item-new-menu
					ul.menu
						li.item.main-option(v-for="menu of menuJson" :key="menu.id"  v-if="menu.title != 'Login'" :class="{'hovering': menu.is_hovering}" @mouseover="showSubelement(menu)" @mouseleave="hideSubelement(menu)" @click="trackAction('Menu Navigation Click', {'title': `${menu.title}`})")
							a(:href="menu.url")
								| {{menu.title}}
								search-icon.search-icon(v-if="menu.title == 'Search'")
							.sub-menu(v-if="menu.children.length > 0")
								.menu-wrap
									.item.menu-subtitle(v-for="submenu of menu.children" :key="submenu.id")
										.wrap-option
											span.menu-heading
												| {{submenu.title}}
											ul.sub-menu2(v-if="submenu.children")
												li.menu-option(v-for="child of submenu.children" v-if="child.show_logged_out" :key="child.id" :class="{'subscription-link': child.title == 'Subscribe'}")
													a(v-if="child.id == '21'" :href="child.url" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
														| {{child.title}} {{currentYear}}
													a(v-else :href="child.url" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
														| {{child.title}}

												no-ssr(v-for="child of submenu.children" v-if="$store.state.userIsLoggedIn && !child.show_logged_out" :key="child.id")
													li.menu-option.no-ssrr
														a(:href="child.url" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
															| {{child.title}}
								.section-cta(v-if="menu.cta_data")
									.text
										p {{menu.cta_data.text}}
									.button
										sfc-simple-button(v-if="menu.cta_data.link" :text="menu.cta_data.btn_text" :orange="true" :mediumSize="true" :link="true" :href="menu.cta_data.link" @click="trackAction('CTA Click - ' + menu.cta_data.btn_text, {section: 'Navigation'})")
										state-of-residence-question(v-if="menu.cta_data.function" :button-text="menu.cta_data.btn_text" @click="trackActionGetStarted('Savings Center Navigation', 'CTA Menu Click')" ref="stateOfResidenceComponent")
				.third-item-new-menu
					ul.menu
						li.item.main-option.login-menu(v-for="menu of menuJson" :key="menu.id"  v-if="menu.title == 'Login'" :class="{'hovering': menu.is_hovering}" @mouseover="showSubelement(menu)" @mouseleave="hideSubelement(menu)")
							no-ssr
								div.no-ssrr(v-if="!$store.state.userIsLoggedIn")
									a(@click="openLogin")
										| Login


								div(v-else)
									a(@click.prevent="")
										| Account
									.sub-menu
										.menu-wrap
											.item.menu-subtitle.logged-in
												.wrap-option
													ul.sub-menu2
														li.menu-option
															a(href="/manage_account/")
																| Manage account
														li.menu-option
															a(:href="logoutUrl")
																| Logout

					sfc-simple-button.start-saving(text="Get Started" :white="true" :mediumSize="true" @click="openSavingsCenter();trackActionGetStarted('Savings Center Navigation', 'Header menu click')" :loading="loadingSavingsCenterUser")
</template>

<style lang="stylus">
	.menu-savings-center-spinner
		display: inline-block
</style>

<style lang="stylus" scoped>
	@import '~assets/css/redesign-v1/variables.styl'

	.new-header-back-desktop
		background-color: blue-primary
		color: #fff
		position: relative
		top: 0
		width: 100%
		z-index: 1010

		display: flex
		@media(max-width: 991px)
			display: none
		.menu-container
			max-width: 1176px
			width: 100%
			margin: 0 auto
			padding: 0 12px
			a
				color: #fff
			.h-content
				align-items: center
				width: 100%
				display: flex
				display: -webkit-flex
				flex-wrap: wrap
				-webkit-flex-wrap: wrap
				align-content: center
				height: 100px

				.first-item-new-menu
				.second-item-new-menu
				.third-item-new-menu
					display: flex
					align-items: center

				.first-item-new-menu
					svg
						max-width: 100%
						width: 141px
						height: auto

				.second-item-new-menu
					flex-grow: 2

				.second-item-new-menu
				.third-item-new-menu
					height: 100%
					ul.menu
						margin: 0
						padding-left: 20px
						height: 100%
						overflow: hidden
						@media(min-width: 992px) and (max-width: 1100px)
							padding-left: 10px
						li.main-option
							display: inline-block
							list-style: none
							padding: 40px 13px 37px
							margin: 0
							line-height: normal
							height: 100%
							@media(min-width: 992px) and (max-width: 1100px)
								padding: 40px 6px 37px
							&:hover
								background-color: blue-90
							a
								text-decoration none !important
								font-size: body-font-size-sm
								font-weight: body-font-weight-medium
								text-transform uppercase
								padding 0
								.search-icon
									margin-left: 8px
									width: 16px
									height: 16px
									@media(min-width: 992px) and (max-width: 1120px)
										display: none
							.sub-menu
								background-color: #fff
								display: none
								flex-wrap: wrap
								margin-top: 41px
								position: absolute
								padding: 0
								left: 0
								right: 0
								flex-direction: column !important
								justify-content: space-between !important
								box-shadow(0 8px 8px 0 rgba(0, 0, 0, 0.15))
								.menu-wrap
									width: 100%
									max-width: 1176px
									margin: 0 auto
									height: auto
									overflow: hidden
									display: flex
									flex-wrap: wrap
									flex: 1
									justify-content: space-between
									padding: 32px 24px 60px
									.menu-subtitle
										display: flex
										flex: 1
										flex-wrap: wrap
										justify-content: center
										.wrap-option
											.menu-heading
												font-size: 18px
												font-weight: bold
												line-height: normal
												color: body-font-color-black !important
												cursor: default
											a.menu-heading
												text-transform: none
												cursor: pointer
												&:hover
													color: blue-primary !important
													text-decoration: underline !important
											ul.sub-menu2
												margin: 0
												height: auto
												display: flex
												flex-flow: column
												width: 100%
												padding: 0
												li.menu-option
													list-style: none
													margin-top: 16px
													line-height: normal
													a
														font-size: body-font-size-md
														line-height: normal
														color: body-font-color-black !important
														text-transform: none
														font-weight: normal
														&:hover
															color: blue-primary !important
															text-decoration: underline !important
								.section-cta
									display: flex
									justify-content: center
									align-items: center
									padding: 28px 0
									width: 100%
									position: relative
									background-color: gray-5
									.text
										p
											font-size: body-font-size
											font-weight bold
											line-height: body-font-line-height
											color: body-font-color-black
											margin-bottom: 0px
									.button
										margin-left: 32px
										>>>.sfc-simple-button
											width: 200px
										.step-content
											>>>.btn
												width: 200px
												padding: 12px 20px
												font-size: body-font-size-md
												font-weight: body-font-weight-strong
												line-height: normal
												text-transform: uppercase


							&:first-of-type
								.sub-menu
									//display: flex

							&.hovering
								.sub-menu
									display: flex

				.third-item-new-menu
					.menu
						@media(min-width: 992px) and (max-width: 1200px)
							padding-left: 0 !important
						.login-menu
							div
								.sub-menu
									.menu-wrap
										min-height: 170px
										.menu-subtitle
											flex: unset !important
											width: 100% !important
											justify-content: flex-end !important
											margin-right: 14%
											&.logged-in
												margin-right: 12%


					a
						text-decoration: none !important
						font-size: body-font-size-sm
						font-weight: body-font-weight-medium
						text-transform: uppercase
						padding: 0
					>>>.sfc-simple-button
						margin-left: 24px
						@media(min-width: 992px) and (max-width: 1150px)
							margin-left: 10px
							min-width: 100px
						.content
							.button-text
								font-weight: body-font-weight-medium
</style>

<script>
	import SfcLogoDesktop from '@/common/components/icons/redesign-v1/sfc-logo-desktop'
	import SearchIcon from '@/common/components/icons/redesign-v1/search-icon'
	import SfcSimpleButton from '@/common/components/redesign-v1/sfc-simple-button'
	import SfcTrackingService from "@/lib/sfc-tracking-service"
	import Spinner from 'vue-simple-spinner/src/components/Spinner.vue'
	import StateOfResidenceQuestion from '@/common/components/savings-center/v3/onboarding/redesign-v1/state-of-residence.vue'
	import MenuJSON from '@/menu-footer.json'

	export default {

	components:{
		SfcLogoDesktop,
		SearchIcon,
		SfcSimpleButton,
		Spinner,
		StateOfResidenceQuestion,
		MenuJSON
	},

	data() {
		return {
			currentYear: '',
			loadingSavingsCenterUser: false,
			savingsCenterFlow: false,
			logoutUrl: '/logout/',
			menuTimeout: undefined,
			menuJson: MenuJSON['menu']
		}
	},

	mounted() {
		this.logoutUrl = `/logout/?return_url=${window.location.href}`

		this.currentYear = new Date().getFullYear()

		if(this.isIE()){
			let submenus = document.querySelectorAll('.second-item-new-menu .menu-wrap')
			submenus[0].style.minHeight = "400px"
			submenus[1].style.minHeight = "300px"
			submenus[2].style.minHeight = "480px"
			submenus[3].style.minHeight = "350px"
		}
	},

	methods: {

		async openSavingsCenter(){
			let nextPageUrl = false

			nextPageUrl = await this.nextStep()

			if(nextPageUrl){
				window.location.href = nextPageUrl
			}else{
				setTimeout(()=>{
					this.$sfcModal.open("sfc-onboarding-modal-v3-2", {savingsCenterFlow: true})
				},0)
			}
		},

		async nextStep(){
			const tokenSavingsCenterInfo = this.$cookies.get("savings-center-info")

			if (tokenSavingsCenterInfo){
				if (this.$store.state.collegeSavingsUserOnboarding  && this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]){
					return "/savings-center/" + this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]
				}
			}
			else{
				return false
			}

		},

		trackAction(eventDescription, additionalInformation = false){
			SfcTrackingService.trackAction(eventDescription, "Navigation", "2", additionalInformation)
		},
		trackActionGetStarted(eventDescription, eventAction, additionalInformation = false){
			SfcTrackingService.trackAction(eventDescription, eventAction, "", additionalInformation)
		},

		showSubelement(menu){
			clearTimeout(this.menuTimeout)
			this.menuTimeout = setTimeout(() => {
				for(let m of this.menuJson){
					m.is_hovering = false
				}
				menu.is_hovering = true
			}, 400)
	 	},

	 	hideSubelement(menu){
	 		clearTimeout(this.menuTimeout)
			setTimeout(() => {
				menu.is_hovering = false
			}, 200)
	 	},

		openLogin(){
			window.location.href = '/login'
		},

		obModalShow(){
			this.savingsCenterFlow = false
		},

		runMethod(func){
			this[func]()
		},

		isIE(){
			let ua = window.navigator.userAgent
			let msie = ua.indexOf('MSIE ')
			if (msie > 0) {
				return true
			}

			let trident = ua.indexOf('Trident/')
			if (trident > 0) {
				return true
			}

			let edge = ua.indexOf('Edge/')
			if (edge > 0) {
				return false
			}

			// other browser
			return false
		}
	}
}
</script>
